import React, { useState } from 'react';
import LogoSection from './LogoSection';
import { useAuth } from '../../context/AuthContext';
import { usePermissions } from '../../utils/usePermissions';
import ConfirmationModal from './ConfirmationModal';
import { getImageUrl } from '../../utils/imageUrl';
import './Sidebar.css';

const menuItems = [
  {
    id: 'Dashboard',
    label: 'Dashboard',
    permission: null,  // No permission check for dashboard
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
      </svg>
    ),
  },
  {
    id: 'Songs',
    label: 'Songs',
    permission: 'songs',
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 18V5l12-2v13" />
        <circle cx="6" cy="18" r="3" />
        <circle cx="18" cy="16" r="3" />
      </svg>
    ),
  },
  {
    id: 'Albums',
    label: 'Albums',
    permission: 'albums',
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    ),
  },
  {
    id: 'Artists',
    label: 'Artists',
    permission: 'artists',
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
  {
    id: 'Ringtone',
    label: 'Ringtone',
    permission: 'ringtones',
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
        <line x1="12" y1="19" x2="12" y2="22" />
      </svg>
    ),
  },
  {
    id: 'Distributor',
    label: 'Distributor',
    permission: 'distributor',
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
  },
  {
    id: 'Ownership',
    label: 'Ownership',
    permission: 'ownership',
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
  {
    id: 'Notes & Cases',
    label: 'Notes & Cases',
    permission: 'notes_cases',
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
  {
    id: 'Recode Labels',
    label: 'Recode Labels',
    permission: 'record_labels',
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 7h16" />
        <path d="M4 12h10" />
        <path d="M4 17h7" />
        <path d="M16 17l2 2 4-4" />
      </svg>
    ),
  },
  {
    id: 'E-Accounts',
    label: 'E-Accounts',
    permission: 'eaccounts',
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <path d="M7 15h.01" />
        <path d="M17 15h.01" />
      </svg>
    ),
  },
  {
    id: 'Calendar',
    label: 'Calendar',
    permission: 'calendar',
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <path d="M8 14h.01" />
        <path d="M12 14h.01" />
        <path d="M16 14h.01" />
      </svg>
    ),
  },
  {
    id: 'Revenue',
    label: 'Revenue',
    permission: 'revenue',
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3v18" />
        <path d="M17 7c-2 0-3 2-5 2s-3-2-5-2" />
        <path d="M17 17c-2 0-3-2-5-2s-3 2-5 2" />
        <path d="M4 7h16" />
        <path d="M4 17h16" />
      </svg>
    ),
  },
  {
    id: 'Settings',
    label: 'Settings',
    permission: 'settings',
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    ),
  },
];

function Sidebar({ activePage, onSelect, isCollapsed, onToggleCollapse }) {
  const { user, logout } = useAuth();
  const { canViewModule } = usePermissions();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const defaultAvatar = "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150&h=150";

  // Filter menu items by permissions if non-Super Admin
  const filteredMenuItems = menuItems.filter(item => {
    // Always show Dashboard
    if (item.id === 'Dashboard') return true;
    
    // Users can only see modules they have view permission for
    return item.permission && canViewModule(item.permission);
  });

  const handleLogoutConfirm = async () => {
    setShowLogoutConfirm(false);
    await logout();
  };

  return (
    <aside className={`sidebar-container ${isCollapsed ? 'collapsed' : ''}`}>
      <LogoSection isCollapsed={isCollapsed} onToggle={onToggleCollapse} />
      
      <nav className="sidebar-navigation">
        <ul className="sidebar-menu-list">
          {filteredMenuItems.map((item) => {
            const isActive = activePage === item.id;
            const strokeColor = isActive ? '#ffffff' : '#64748b';
            
            return (
              <li key={item.id} className="sidebar-menu-item">
                <button
                  className={`sidebar-menu-button ${isActive ? 'active' : ''}`}
                  onClick={() => onSelect(item.id)}
                  title={isCollapsed ? item.label : undefined}
                >
                  <span className="sidebar-menu-icon">
                    {item.icon(strokeColor)}
                  </span>
                  {!isCollapsed && <span className="sidebar-menu-label">{item.label}</span>}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
      
      <div className="sidebar-footer">
        <div 
          className="admin-profile"
          onClick={() => onSelect('Profile')}
          style={{ cursor: 'pointer' }}
          title="View Profile"
        >
          <img
            src={getImageUrl(user?.profile_image) || defaultAvatar}
            alt={`${user?.firstname || 'User'}`}
            className="admin-avatar"
            onError={(e) => { e.target.src = defaultAvatar; }}
          />
          {!isCollapsed && (
            <div className="admin-profile-details" style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
              <span className="admin-user-name" style={{ fontSize: '13px', fontWeight: '600', color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {user ? `${user.firstname} ${user.lastname}` : 'User Profile'}
              </span>
              <span className="admin-user-role" style={{ fontSize: '11px', color: '#64748b' }}>
                {user?.role_name || 'Member'}
              </span>
            </div>
          )}
          {!isCollapsed && (
            <button
              type="button"
              className="sidebar-logout-btn"
              onClick={(e) => {
                e.stopPropagation();
                setShowLogoutConfirm(true);
              }}
              title="Logout"
              style={{ padding: '4px', color: '#94a3b8', borderRadius: '4px', border: 'none', background: 'none', cursor: 'pointer' }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
            </button>
          )}
        </div>
      </div>

      {/* Global Confirmation Modal for Logout */}
      <ConfirmationModal
        isOpen={showLogoutConfirm}
        type="danger"
        title="Confirm Logout"
        message="Are you sure you want to log out of your session?"
        confirmLabel="Yes, Logout"
        cancelLabel="Cancel"
        onConfirm={handleLogoutConfirm}
        onCancel={() => setShowLogoutConfirm(false)}
      />
    </aside>
  );
}

export default Sidebar;
